<div class="dialog-header">
  <h2>Edit Coach</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="form-group">
    <label>Private Training Coach</label>
    <select [(ngModel)]="selectedRep">
      <option *ngFor="let rep of representatives" [value]="rep.value">
        {{ rep.label }}
      </option>
    </select>
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
